import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { LoggedInUserStateType } from './types/loggedInUserState.type'
import { SetUserInfoPayloadType } from './types/setUserInfoPayload.type'

const initialState: LoggedInUserStateType = {
  id: null,
  fullname: null,
  userPhone: null,
  userDomain: null,
  teamName: null,
  userPosition: null,
  userPositionLevel: null,
  userProductType: null,
}

const loggedInUser = createSlice({
  name: 'loggedInUser',
  initialState,
  reducers: {
    setUserInfo(state, { payload }: PayloadAction<SetUserInfoPayloadType>) {
      state.id = payload.id
      state.fullname = payload.fullname
      state.userPhone = payload.userPhone
      state.userDomain = payload.userDomain
      state.teamName = payload.teamName
      state.userPosition = payload.userPosition
      state.userPositionLevel = payload.userPositionLevel
      state.userProductType = payload.userProductType
    },
  },
})

export const { setUserInfo } = loggedInUser.actions
export default loggedInUser.reducer
